import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  previousQuestion: {
    form: '',
    index: 0,
  },
  lead_config: {
    product: '',
    category: '',
    lead_created: false
  },
  mcp_dpe: '',
  dwelling_tunnel_form: [],
  answers_dwelling_step: {},
  dwelling_step_resume: {},
  answers_lead_form: {},
  aids_tunnel_form: [],
  answers_aids_step: {},
  answers_saving_options: {},
  simulatorSteps: {
    steps: [
      {name: 'dwelling', label:"Votre habitation"},
      {name: 'save_energy', label:"Vos économies d'énergie"},
      {name: 'aids', label:"Vos aides de l'État"},
    ],
    currentStep: '',
    validatedSteps: []
  },
  simulator_path_infos: {
    is_low_dpe_eligible_to_aids: false,
    overall_renovation_contact: false,
    is_home_owner: false,
  },
  gtm_events_datas: {}
};

export default {
  state,
  actions,
  mutations,
  getters,
};
